module.exports = __webpack_public_path__ + "img/bg-party.1c8a0875.png";